import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Utility from '../utilities/utility';
import placeholder from '../placeholder.png';

class ProductImagesModal extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            selectedImage: ''
        };
    }

    componentDidUpdate(previousProps) {
        if (
            this.props.show &&
            (!previousProps.show || previousProps.images !== this.props.images || previousProps.mainImage !== this.props.mainImage)
        ) {
            this.setState({
                selectedImage: this.getFirstImageUrl()
            });
        }
    }

    getImageUrl = (image) => {
        if (Utility.isEmpty(image)) {
            return placeholder;
        }

        if (typeof image === 'string') {
            return image;
        }

        if (!Utility.isEmpty(image.fullUrl)) {
            return image.fullUrl;
        }

        if (!Utility.isEmpty(image.url)) {
            return image.url;
        }

        if (!Utility.isEmpty(image.name)) {
            return `${process.env.REACT_APP_API_URL}/images/${image.name}`;
        }

        return placeholder;
    }

    getDisplayImages = () => {
        const images = this.props.images || [];

        if (images.length > 0) {
            return images;
        }

        if (!Utility.isEmpty(this.props.mainImage)) {
            return [this.props.mainImage];
        }

        return [];
    }

    getFirstImageUrl = () => {
        const images = this.getDisplayImages();

        if (images.length > 0) {
            return this.getImageUrl(images[0]);
        }

        return placeholder;
    }

    selectImage = (image) => {
        this.setState({
            selectedImage: this.getImageUrl(image)
        });
    }

    render() {
        const images = this.getDisplayImages();
        const selectedImage = this.state.selectedImage || this.getFirstImageUrl();

        return (
            <Modal show={this.props.show} onHide={this.props.onHide} size="lg" centered>
                <Modal.Header closeButton>
                    <Modal.Title>{this.props.title || 'Images du produit'}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    {this.props.loading ? (
                        <div className="text-center p-4">Chargement des images...</div>
                    ) : images.length > 0 ? (
                        <div>
                            <div className="text-center mb-3">
                                <img
                                    src={selectedImage}
                                    alt="Product"
                                    className="img-fluid rounded border"
                                    style={{ maxHeight: '65vh', objectFit: 'contain' }}
                                    onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src = placeholder;
                                    }}
                                />
                            </div>

                            <div className="d-flex flex-wrap justify-content-center gap-2">
                                {images.map((image, index) => {
                                    const imageUrl = this.getImageUrl(image);
                                    const imageKey = image && image.imageId ? image.imageId : index;

                                    return (
                                        <img
                                            key={imageKey}
                                            src={imageUrl}
                                            alt={`Product ${index + 1}`}
                                            className={selectedImage === imageUrl ? 'rounded border border-primary' : 'rounded border'}
                                            style={{
                                                width: '90px',
                                                height: '90px',
                                                objectFit: 'cover',
                                                cursor: 'pointer',
                                                padding: selectedImage === imageUrl ? '2px' : '0'
                                            }}
                                            onClick={() => this.selectImage(image)}
                                            onError={(e) => {
                                                e.target.onerror = null;
                                                e.target.src = placeholder;
                                            }}
                                        />
                                    );
                                })}
                            </div>
                        </div>
                    ) : (
                        <div className="text-center p-4 text-muted">Aucune image trouvée pour ce produit.</div>
                    )}
                </Modal.Body>
            </Modal>
        );
    }
}

export default ProductImagesModal;
